import { Link } from "react-router-dom";
import Privacy from "./PrivacyPage";
import Rankings from "./Rankings";
import Level from "./Level";

const translations = {
    en: {
        welcomeMessage: "Join the Fun!",
        login: "Login",
        email: "Email",
        register: "Register",
        username: "Username", 
        password: "Password",
        language: "Language",
        english: "English", 
        chinese: "Chinese",
        dont_have_account: "Don't have an account?",
        already_have_account: "Already have an account?",
        forgot_password: "Forgot Password?",
        password_error_1: "Password must contain at one special character, and be at least 8 characters long",
        login_error_1: "Username or password is incorrect",
        register_error_1: "Please enter a username",
        register_error_2: "Please enter a password",
        register_error_3: "Please enter an email",
        register_error_4: "Please enter a valid email",
        reset_passeword_error: "Password and token required",
        reset_passeword_error_2: "Token is required",
        reset_passeword_error_3: "Token is invalid",
        reset_passeword_error_4: "Email must be a UB email",
        enter_email:"Enter your email to send a link to reset your password",
        token: "Token",
        back: "Back",
        your_feed: "Your Feed",
        make_post: "Make Post",
        comment: "Comment",
        like: "Like",
        discover: "Discover",
        feed: "Feed",
        ranking: "Rankings",
        profile: "Profile",
        find: "Find Players",
        logout: "Logout",
        send_link: "send reset link",
        new_password: "New Password",
        submit: "Submit",
        load_more: "Load More",
        twitch_text: "watch popular twitch streams of your favorite games",
        about: "About Us",
        posts: "Posts",
        edit_posts: "Edit Posts",
        post_comment: "Post Comment",
        status: "Status",
        save_change: "Save Changes",
        delete_account_message: "Are you sure you want to delete your account?",    
        yes: "Yes",
        no: "No",
        menu: "Menu",
        edit_profile: "Edit Profile",
        account_settings: "Account Settings",
        playing: "Playing",
        view_profile: "View Profile",
        search_text: "Posts, @users, and @players...",
        no_post: "No Posts Found",
        privacy: "Privacy Settings",
        change_password: "Change Password",
        make_private: "Make Private",
        show_ranking: "Show Ranking",
        delete_account: "Delete Account",
        seek_player: "Seeking Players",
        player_info: "Player Info",
        player_info_text: "Click on a player to get more information",
        looking_for: "Looking for Players?",
        looking_text1: "What kind of players are you looking for?",
        looking_text2: "Please provide your Discord username for communication:",
        describle: "Description",
        link: "Link",
        title: "Title",
        post_text: "What would you like to post?",
        title_error: "Please enter a title",
        post_text_error: "Please enter post information",
        community_error: "Please Select a Community",
        community1: "FPS",
        community2: "Battle-Royale",
        community3: "MOBA",
        community4: "Sandbox",
        community5: "Action-Adventure",
        post: "Post",
        post_added: "Post Added Successfully! You will be redirected shortly.",
        no_file: "No file selected",
        cancel: "Cancel",
        remove_like: "Remove Like Successfully!",
        remove_like_error: "Failed to remove like post",
        like_post: "Like Post Successfully!",
        like_post_error: "Failed to like post",
        comments: "Comments",
        author: "Author",
        view_title_error: "Title Not Found",
        comment_text: "Enter your comment here",
        comment_success: "Comment Posted Successfully!",
        like_comment: "Like Comment Successfully!",
        comment_error1: "Failed to post comment",
        comment_error2: "Please enter a comment",
        file: "File:",
        in_community: "in community:",
        following: "Following",
        followers: "Followers",
        blocked: "Blocked",
        block: "Block",
        unblock: "Unblock",
        requests: "Requests",
        message: "Message",
        created: "Created:",
        apex_legends: "Apex Legends",
        counter_strike: "Counter Strike",
        dota_2: "Dota 2",
        fortnite: "Fortnite",
        grand_theft_auto_v: "Grand Theft Auto V",
        league_of_legends: "League of Legends",
        minecraft: "Minecraft",
        roblox: "Roblox",
        teamfight_tactics: "Teamfight Tactics",
        valorant: "Valorant",
        ranks: "Ranks",
        unranked: "Unranked",
        no_rank: "Edit profile to share ranks!",
        add_rank: "Add Rank",
        edit_rank: "Edit Rank",
        follow: "Follow",
        unfollow: "Unfollow",
        not_found: "404 - Not Found",
        not_found_text: "Oops! The page you are looking for is not here.",
        go_back: "Go back to the feed page",

        valorant_iron: "Iron",
        valorant_bronze: "Bronze",
        valorant_silver: "Silver",
        valorant_gold: "Gold",
        valorant_platinum: "Platinum",
        valorant_diamond: "Diamond",
        valorant_ascendant: "Ascendant",
        valorant_immortal: "Immortal",
        valorant_radiant: "Radiant",

        dota_2_herald: "Herald",
        dota_2_guardian: "Guardian",
        dota_2_crusader: "Crusader",
        dota_2_archon: "Archon",
        dota_2_legend: "Legend",
        dota_2_ancient: "Ancient",
        dota_2_divine: "Divine",

        league_of_legends_iron: "Iron",
        league_of_legends_bronze: "Bronze",
        league_of_legends_silver: "Silver",
        league_of_legends_gold: "Gold",
        league_of_legends_platinum: "Platinum",
        league_of_legends_emerald: "Emerald",
        league_of_legends_diamond: "Diamond",
        league_of_legends_master: "Master",
        league_of_legends_grandmaster: "Grandmaster",
        league_of_legends_challenger: "Challenger",

        fortnite_iron: "Iron",
        fortnite_bronze: "Bronze",
        fortnite_silver: "Silver",
        fortnite_gold: "Gold",
        fortnite_platinum: "Platinum",
        fortnite_diamond: "Diamond",
        fortnite_elite: "Elite",
        fortnite_champion: "Champion",
        fortnite_unreal: "Unreal",

        counter_strike_silver: "Silver",
        counter_strike_gold_nova: "Gold Nova",
        counter_strike_master_guardian: "Master Guardian",
        counter_strike_distinguished_master_guardian: "Distinguished Master Guardian",
        counter_strike_legendary_eagle: "Legendary Eagle",
        counter_strike_legendary_eagle_master: "Legendary Eagle Master",
        counter_strike_supreme_master_first_class: "Supreme Master First Class",
        counter_strike_global_elite: "Global Elite",

        apex_legends_bronze: "Bronze",
        apex_legends_silver: "Silver",
        apex_legends_gold: "Gold",
        apex_legends_platinum: "Platinum",
        apex_legends_diamond: "Diamond",
        apex_legends_master: "Master",
        apex_legends_apex_predator: "Apex Predator",
        close: "Close",
        save: "Save",
        members: "Members",
        interest: "Interested?",
        community1_text: "An FPS (First-Person Shooter) game is a video game genre where players experience the game from a first-person perspective and primarily engage in combat using ranged weapons.",
        community2_text:"A battle royale is a multiplayer video game genre where players compete against each other in a last-player-standing deathmatch, typically set in an ever-shrinking play area.",
        community3_text:"MOBA, which stands for Multiplayer Online Battle Arena, is a genre of video games where two teams compete against each other in strategic, objective-based battles.",
        community4_text:"Sandbox games are open-world video games that offer players a large, unrestricted environment to explore and interact with, allowing for freedom in gameplay and player-driven experiences.",
        community5_text:"An action-adventure game is a genre of video game that combines elements of both action games, focusing on combat and challenges, and adventure games, emphasizing exploration, puzzle-solving, and narrative-driven storytelling.",
        leave_community: "Leave Community",
        join_community: "Join Community",
        community: "Community",
        Noob: "Noob",
        Novice: "Novice",
        Apprentice: "Apprentice",
        Journeyman: "Journeyman",
        Expert: "Expert",
        Master: "Master",
        Grandmaster: "Grandmaster",
        Legendary: "Legendary",
        Heroic: "Heroic",
        Mythic: "Mythic",
        Immortal: "Immortal",
        rankings: "Rankings",
        level: "Lv.",
        leaderboard: "Leaderboard",
        xp: "XP",
        upload: "Upload",
        none: "None",
        profanity_filter: "Profanity Filter",
        allow_follow: "Allow Follow",
        ranking_content: "Gain experience by other users liking your posts and comments.",
        find_community: "Find Communities",
        your_communities: "Your Communities",
        request_to_follow: "Request to Follow",
        accept_request: "Accept Request",
        cancel_request: "Cancel Request",
    },
    ch: {
        welcomeMessage: "玩得开心!",
        email: "邮箱",
        login: "登录",
        register: "注册",
        username: "用户名",
        password: "密码",
        language: "语言",
        english: "English",
        chinese: "中文",
        dont_have_account: "没有账号吗？",
        already_have_account: "已经有账号？",
        forgot_password: "忘记密码？",
        password_error_1: "密码必须至少包含8个字,其中至少包含一个特殊字符",
        login_error_1: "用户名或密码错误",
        register_error_1: "请输入用户名",
        register_error_2: "请输入密码",
        register_error_3: "请输入邮箱",
        register_error_4: "请输入有效邮箱",
        reset_passeword_error: "需要密码和验证码",
        reset_passeword_error_2: "需要验证码",
        reset_passeword_error_3: "验证码无效",
        reset_passeword_error_4: "邮箱必须是UB邮箱",
        back: "返回",
        enter_email: "输入您的邮箱以发送重置密码链接",
        send_link: "发送重置链接",
        token: "验证码",
        new_password: "新密码",
        submit: "提交",
        make_post: "发帖",
        your_feed: "您的推荐",
        twitch_text: "观看您最喜欢的游戏的热门直播",
        discover: "发现",
        feed: "推荐",
        ranking: "排名",
        profile: "个人资料",
        logout: "登出",
        find: "找其他玩家",
        about: "关于我们",
        posts: "帖子",
        status: "状态",
        save_change: "保存更改",
        delete_account_message: "您确定要删除您的账户吗？",
        yes: "是",
        no: "否",
        menu: "菜单",
        followers: "粉丝",
        following: "关注",
        edit_profile: "编辑个人资料",
        account_settings: "账户设置",
        playing: "正在玩",
        view_profile: "个人资料",
        search_text: "朋友,游戏,等等...",
        seek_player: "寻找玩家",
        player_info: "玩家信息",
        player_info_text: "点击玩家以获取更多信息",
        looking_for: "寻找玩家吗？",
        looking_text1: "您正在寻找什么样的玩家？",
        looking_text2: "请提供您的 Discord 的链接以进行沟通：",
        describle: "描述",
        link: "链接",
        no_post: "没有找到帖子",
        privacy: "隐私设置",
        change_password: "更改密码",
        make_private: "设为私密",
        show_ranking: "显示排名",
        delete_account: "删除账户",
        title: "标题",
        post_text: "您想发布什么？",
        community: "社区",
        community_error: "请选择一个社区",
        title_error: "请输入标题",
        post_text_error: "请输入帖子信息",
        community1: "第一人称射击游戏",
        community2: "大逃杀",
        community3: "MOBA",
        community4: "沙盒",
        community5: "动作冒险",
        post: "发布",
        no_file: "未选择文件",
        cancel: "取消",
        remove_like: "取消点赞成功",
        remove_like_error: "无法取消点赞",
        like_post: "点赞成功",
        like_post_error: "无法点赞",
        comments: "评论",
        author: "作者",
        view_title_error: "找不到标题",
        comment_text: "在此输入您的评论",
        comment_success: "评论成功发布",
        like_comment: "点赞评论成功",
        comment_error1: "无法发布评论",
        comment_error2: "请输入评论",
        file: "文件:",
        in_community: "在社区:",
        blocked: "黑名单",
        block: "拉黑",
        unblock: "取消拉黑",
        requests: "请求",
        message: "发消息",
        created: "创建时间:",
        apex_legends: "Apex英雄",
        counter_strike: "反恐精英",
        dota_2: "刀塔2",
        fortnite: "堡垒之夜",
        grand_theft_auto_v: "侠盗猎车手5",
        league_of_legends: "英雄联盟",
        minecraft: "我的世界",
        roblox: "Roblox",
        teamfight_tactics: "云顶之弈",
        valorant: "无畏契约",
        ranks: "排位",
        unranked: "未排名",
        no_rank: "编辑个人资料以分享排名！",
        add_rank: "添加排名",
        edit_rank: "编辑排名",
        follow: "关注",
        unfollow: "取消关注",


        valorant_iron: "铁牌",
        valorant_bronze: "铜牌",
        valorant_silver: "银牌",
        valorant_gold: "金牌",
        valorant_platinum: "白金",
        valorant_diamond: "钻石",
        valorant_ascendant: "超凡入圣",
        valorant_immortal: "神话",
        valorant_radiant: "辐能战魂",

        dota_2_herald: "先锋",
        dota_2_guardian: "卫士",
        dota_2_crusader: "十字军",
        dota_2_archon: "执政官",
        dota_2_legend: "一代传奇",
        dota_2_ancient: "万古流芳",
        dota_2_divine: "超凡入圣",

        league_of_legends_iron: "坚韧黑铁",
        league_of_legends_bronze: "英勇青铜",
        league_of_legends_silver: "不屈白银",
        league_of_legends_gold: "荣耀黄金",
        league_of_legends_platinum: "华贵铂金",
        league_of_legends_emerald: "流光翡翠",
        league_of_legends_diamond: "璀璨钻石",
        league_of_legends_master: "超凡大师",
        league_of_legends_grandmaster: "傲世宗师",
        league_of_legends_challenger: "最强王者",

        fortnite_iron: "黑铁",
        fortnite_bronze: "青铜",
        fortnite_silver: "白银",
        fortnite_gold: "黄金",
        fortnite_platinum: "铂金",
        fortnite_diamond: "钻石",
        fortnite_elite: "精英",
        fortnite_champion: "冠军",
        fortnite_unreal: "虚幻",

        counter_strike_silver: "白银",
        counter_strike_gold_nova: "黄金新星",
        counter_strike_master_guardian: "大师级守卫",
        counter_strike_distinguished_master_guardian: "杰出的大师级守卫",
        counter_strike_legendary_eagle: "传奇之鹰",
        counter_strike_legendary_eagle_master: "大师级传奇之鹰",
        counter_strike_supreme_master_first_class: "无上之首席大师",
        counter_strike_global_elite: "全球精英",

        apex_legends_bronze: "青铜",
        apex_legends_silver: "白银",
        apex_legends_gold: "黄金",
        apex_legends_platinum: "铂金",
        apex_legends_diamond: "钻石",
        apex_legends_master: "大师",
        apex_legends_apex_predator: "猎杀者",
        close: "关闭",
        save: "保存",
        load_more: "加载更多",
        leave_community: "离开社区",
        join_community: "加入社区",
        members: "成员",
        interest:"感兴趣吗？",
        community1_text: "第一人称视角射击游戏顾名思义就是以玩家的主观视角来进行射击游戏。玩家们不再像别的游戏一样操纵屏幕中的虚拟人物来进行游戏,而是身临其境的体验游戏带来的视觉冲击,这就大大增强了游戏的主动性和真实感。主要使用远程武器进行战斗。",
        community2_text:"大逃杀是一种多人在线游戏类型,玩家在其中在一个不断缩小的游戏地图上进行战斗,直到只剩下一名玩家或一支队伍。这种游戏类型通常是最后一名存活的玩家或队伍获胜。",
        community3_text:"MOBA是多人在线战术竞技游戏的缩写是一种电子竞技游戏类型,玩家在其中组成两支队伍,互相对抗,争夺对方的基地。每个玩家控制一个角色,这些角色有着不同的技能和特点。",
        community4_text:"沙盒游戏是一种开放世界的电子游戏,玩家可以在其中自由探索和互动,享受游戏中的自由度和玩家驱动的体验。",
        community5_text:"动作冒险游戏是一种结合了动作游戏和冒险游戏元素的游戏类型,重点放在战斗和挑战上,以及探索、解谜和叙事驱动的故事叙述。",
        post_added: "成功添加帖子! 您将转跳到社区。",
        not_found: "404 - 未找到",
        not_found_text: "糟糕！您要找的页面不在这里。",
        go_back: "返回到主页页面",
        Noob: "新手",
        Novice: "初学者",
        Apprentice: "学徒",
        Journeyman: "熟手",
        Expert: "专家",
        Master: "大师",
        Grandmaster: "宗师",
        Legendary: "传奇",
        Heroic: "英雄",
        Mythic: "神话",
        Immortal: "不朽",
        rankings: "排名",
        leaderboard: "排行榜",
        xp: "经验",
        upload: "上传",
        level: "等级:",
        edit_posts: "编辑帖子",
        none: "无链接",
        profanity_filter: "脏话过滤器",
        allow_follow: "允许关注",
        ranking_content: "通过其他用户喜欢您的帖子和评论来获得经验。",
        find_community: "找社区",
        your_communities: "您的社区",
        request_to_follow: "请求关注",
        accept_request: "接受请求",
        cancel_request: "取消请求",
    }   
  };
  export default translations;